import folderStore, { Folder } from 'owa-folders';
import {
    isDeletedItemsFolderFromAnyMailbox,
    isUnderDeletedItemsFolderFromAnyMailbox,
} from 'owa-mail-store';

/**
 * Evaluates whether the folder is a deleted items folder of under the deleted items folder
 * @param folderId Id of the folder to look up
 */
export default function isDeletedOrUnderDeletedItemsFolder(folderId: string) {
    const folder: Folder = folderStore.folderTable.get(folderId);
    return (
        isDeletedItemsFolderFromAnyMailbox(folderId) ||
        isUnderDeletedItemsFolderFromAnyMailbox(folder)
    );
}
